export default function (nga, admin, activities, groups, exercises, properties, values) {
    var evaluations = admin.getEntity('evaluations')
            .identifier(nga.field('evaluation_id'))
    evaluations.listView()
        .title('{{ "Evaluations" | translate }}')
        .fields([
            nga.field('date', 'date')
                .format('shortDate')
                .label('Date'),
            nga.field('activity_name', 'string')
                .label('Activity'),
            nga.field('group_name', 'string')
                .label('Group'),
            nga.field('exercise_title', 'string')
                .label('Title'),
            nga.field('property_name', 'string')
                .label('Property'),
            nga.field('value_name', 'string')
                .label('Value')
        ])
        .filters([
            nga.field('activity_id', 'reference')
                .targetEntity(activities)
                .targetField(nga.field('name'))
                .filters([
                    nga.field('with_exercises').defaultValue(true)
                ])
                .label('Activity'),
            nga.field('group_id', 'reference')
                .targetEntity(groups)
                .targetField(nga.field('name'))
                .label('Group'),
            nga.field('property_id', 'reference')
                .targetEntity(properties)
                .targetField(nga.field('name').map(function(value, entry) {
                    return entry['activity.name'] + ' - '+ value;
                }))
                .label('Property'),
            nga.field('value_id', 'reference')
                .targetEntity(values)
                .targetField(
                    nga.field('name').map(function(value, entry) {
                        return entry['activity.name'] + ' - ' + entry['property.name'] + ' - '+ value;
                    })
                )
                .label('Value'),
            nga.field('q', 'template')
                .label('Exercise')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'),
            /*
             * FIXME:
             * A reference field by exercise doesn't work properly. It displays
             * only the first 30 exercises (as the request uses a per_page
             * attribute of 30) and doesn't perform an additional lookup once
             * the user introduces a text in the search box.
             */
            // nga.field('exercise_id', 'reference')
            //     .targetEntity(exercises)
            //     .targetField(nga.field('title'))
            //     .label('Exercise')
            nga.field('months', 'template')
                /* FIXME: https://github.com/marmelab/ng-admin/issues/1204
                 * we'd like to pin this filter but unfortunately if we
                 * do that the request wouldn't have our default value added.
                 * // .pinned(true)
                 */
                .label('Time range')
                .defaultValue('2')
                // FIXME: convert-to-number directive keeps sending months filter as strings
                .template(`
<div class="input-group">
    <select ng-model="value" class="form-control">
        <option value="2">{{ "LAST_N_MONTHS" | translate : \'{ amount: 2 }\' }}</option>
        <option value="3">{{ "LAST_N_MONTHS" | translate : \'{ amount: 3 }\' }}</option>
        <option value="6">{{ "LAST_N_MONTHS" | translate : \'{ amount: 6 }\' }}</option>
    </select>
</div>`)
        ])
        .sortField('date')
        .sortDir('DESC')
        .actions(['filter'])
        .listActions([]);
    return evaluations;
}



// WEBPACK FOOTER //
// ./js/evaluations/config.js